module.exports = __webpack_public_path__ + "static/media/success.fa79b9ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/images/success.svg
// module id = 1251
// module chunks = 0